import $api from "../../../http"

export const getListLeagues = async (region) => {
  return await $api
    .get(`/league/list?page=1&per_page=0&sort=country.name&order=asc&region=${region}`)
    .then((response) => response.data)
}
